import Axios from '../../axiosConfig';
import { BACKEND_URL } from '../../config';
import { configure, runInAction, makeAutoObservable } from 'mobx';
import FeedbackDto, { FeedbackType } from '../../types/feedback';

configure({ enforceActions: 'observed' });

export default class FeedbackModule {
    private types: FeedbackType[] = [];
    private allFeedbacks: FeedbackDto[] = [];

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public get feedbacks(): FeedbackDto[] {
        return this.allFeedbacks;
    }

    public async fetchFeedbackTypes(): Promise<void> {
        const response = await Axios({
            method: 'GET',
            url: BACKEND_URL + 'feedback/feedbackTypes',
        });
        runInAction(() => (this.types = response.data));
    }

    public async sendFeedback(feedback: FeedbackDto): Promise<void> {
        await Axios({
            method: 'POST',
            url: BACKEND_URL + 'feedback/saveFeedback',
            data: feedback,
        });
    }

    public async fetchFeedbacks(): Promise<void> {
        const response = await Axios({
            method: 'GET',
            url: BACKEND_URL + 'feedback/allFeedback',
        });
        if (response.status === 200) runInAction(() => (this.allFeedbacks = response.data));
    }

    public get feedbackTypes(): FeedbackType[] {
        return this.types;
    }

    public getFeedbackTypeById(id: number): FeedbackType | null {
        return this.feedbackTypes.find((type) => type.id === id) || null;
    }
}
